import Vue from 'vue'
import {
    Button,
    Tabbar,
    TabbarItem,
    Grid,
    GridItem,
    Image as VanImage,
    Divider,
    Col,
    Row,
    Tab,
    Tabs,
    Icon,
    Picker,
    Popup,
    Cell,
    CellGroup,
    Form,
    Field,
    RadioGroup,
    Radio,
    Toast,
    DatetimePicker,
    ActionSheet,
    Pagination,
    Empty,
    List,
    NavBar,
    DropdownMenu,
    DropdownItem
} from 'vant'

Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Button)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(VanImage)
Vue.use(Divider)
Vue.use(Col)
Vue.use(Row)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Icon)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Form)
Vue.use(Field)
Vue.use(Toast)
Vue.use(DatetimePicker)
Vue.use(ActionSheet)
Vue.use(Pagination)
Vue.use(Empty)
Vue.use(List)
Vue.use(NavBar)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
